import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Image } from '@opendoor/atoms/image';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentLwcImageCard } from 'declarations/contentful';

import Grid from './Grid';

const RenderLWCImageCard = (entry: ILpComponentLwcImageCard) => {
  const { fields, sys } = entry;
  const desktopImageSourceUrl = fields?.desktopImage;
  const mobileImageSourceUrl = fields?.mobileImage;
  const isSmallPadding = fields?.verticalPadding === 'Small';

  if (sys.locale === 'es') return;

  return (
    <Col
      analyticsName={`cosmos-landing-page-lwc-image-card-${fields?.analyticsId}`}
      trackImpression
    >
      <Grid backgroundColor="$backgroundSecondary">
        <Col
          className={cn(
            'col-span-12 w-full overflow-hidden rounded-4xl bg-od-bg-primary',
            'h-154 md:h-113 lg:h-180',
            'md:flex-row',
            isSmallPadding ? 'my-8 md:my-12' : 'my-40',
          )}
        >
          <Col className="justify-start p-8 pr-6 pb-11 md:pr-8 md:pb-8 lg:p-16 xl:p-20">
            {fields?.subtitle && (
              <Row className="grow pb-3 md:pb-0">
                <Text as="p" className="block text-body-lg font-medium text-od-content-primary">
                  {fields.subtitle}
                </Text>
              </Row>
            )}
            <Col className="gap-8">
              <Col className="w-full max-w-78 md:max-w-68 lg:max-w-125">
                <Text as="p" className="block text-subheader-md lg:text-header-lg">
                  {fields.title}
                </Text>
              </Col>
              {fields?.ctaLink && fields?.ctaDisplayText && (
                <Button
                  variant="primary"
                  aria-label={`Go to page to ${fields?.ctaDisplayText}`}
                  analyticsName={`cosmos-landing-page-lwc-image-card-cta-${fields?.analyticsId}`}
                  href={fields.ctaLink}
                  size="sm"
                  className="max-w-41"
                >
                  {fields?.ctaDisplayText}
                </Button>
              )}
            </Col>
          </Col>
          <Box className="flex-1 md:p-4 lg:p-5">
            <Box className="grid h-full w-full overflow-hidden md:rounded-2xl">
              <Image
                src={mobileImageSourceUrl}
                alt="illustration of a home"
                loading="lazy"
                decoding="async"
                sources={
                  desktopImageSourceUrl
                    ? [{ srcSet: desktopImageSourceUrl, media: '(min-width: 768px)' }]
                    : undefined
                }
                className="block h-full w-full object-cover object-[80%]"
              />
            </Box>
          </Box>
        </Col>
      </Grid>
    </Col>
  );
};

const LWCImageCard: EntryComponent<ILpComponentLwcImageCard> = {
  render: RenderLWCImageCard,
};

export default LWCImageCard;
